import { render, staticRenderFns } from "./shipments-modal-send.vue?vue&type=template&id=44a15960&scoped=true&"
import script from "./shipments-modal-send.ts?vue&type=script&lang=ts&"
export * from "./shipments-modal-send.ts?vue&type=script&lang=ts&"
import style0 from "./shipments-modal-send.scss?vue&type=style&index=0&id=44a15960&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a15960",
  null
  
)

export default component.exports